module.exports = __webpack_public_path__ + "static/ofcar4-7967646d9669e7abfa4f1cd92bb63218.jpg";